import { environment } from '../environments/environment';

export default {
  api: {
    production_link: "https://glomdjzpo5.execute-api.sa-east-1.amazonaws.com/v1",
    development_link: "https://glomdjzpo5.execute-api.sa-east-1.amazonaws.com/v1"
  },
  me: {
    cache_name: 'user',
    login_field: 'Nome de Usuário'
  },
  system: {
    register: true,
    name: 'BRPREV',
    copyright: '© 2020 BRPREV',
    logo: 'assets/images/logo/logo.png',
    recover_password: 'sms'
  },
  developer: {
    name: '',
    link: ''
  },
  whatsapp: {
    // true: permite enviar mesmo sem instância conectada; a mensagem entra na fila (backend retorna 202).
    // false: bloqueia o envio quando não houver instância conectada.
    allowSendWithoutConnectedInstance: true
  }
};
